const format = (value: number) => {
    if (Number.isNaN(value)) return ""
    if (value >= 0) return value.toString()
    return ""
}

export const customParseInt = (value: string) => {
    const parsedValue = parseInt(value, 10)
    return format(parsedValue)
}

export const customParseFloat = (value: string) => {
    const parsedValue = parseFloat(value)
    return format(parsedValue)
}
